export default __webpack_public_path__ + "media/zurb/img/services/tools/helio-screenshot2-28db6e67cfaa28edc1c2b24ca3bcb6aa.png";